import React from 'react';
import { RouteComponentProps, withRouter } from "react-router-dom";
import { Location } from 'history';
import gtag from './gtag.js';

class HistoryTracker extends React.Component<RouteComponentProps> {
  
  private unlisten: () => void = () => { return };
  
  private useLog = false;
  
  componentDidMount(): void {
    this.logHistory(this.props.location, "");
    this.unlisten = this.props.history.listen(this.logHistory.bind(this));
  }
    
  componentWillUnmount(): void {
    this.unlisten();
  }
  
  
  private logHistory(location: Location, action: string) {
    this.debugLog(location, action);
    const path = `${location.pathname}${location.hash}${location.search}`;
        
    gtag('event', 'page_view', {
      page_path: path,
      send_to: '<%GA_TOKEN%>'
    })
  }
  
  
  private debugLog(location: Location, action: string): void {
    if (!this.useLog) return;
    console.group("%c GA history to register:", "background: rebeccapurple; color: white; font-size: 16px;");
    console.log(`The last navigation action was ${action}`)
    console.log(`The current URL is ${location.pathname}${location.hash}${location.search}`)
    console.groupEnd();
  }
  
  render(): JSX.Element {
    return (
      <></>
    );
  }
}

export default withRouter(HistoryTracker);
